import React, { useEffect, useRef, useState } from "react";
import styles from "./PartnerHeader.module.scss";
import cart_icon from "../../../assets/svg/cart_icon.svg";
// import aircoin_icon from "../../../assets/svg/aircoin_icon.svg";
import profile_partner_icon from "../../../assets/svg/userProfile.svg";
import myTeam from "../../../assets/svg/myTeam.svg";
import logout_outlined from "../../../assets/svg/logout_outlined.svg";
import profile_outlined from "../../../assets/svg/profile_outlined.svg";
import partner_logo from "../../../assets/svg/partner_logo.svg";
import order_icon from "../../../assets/svg/order_icon.svg";
// import notification_partner from "../../../assets/svg/notification_partner.svg";
import { connect } from "react-redux";
import { useNavigate } from "react-router-dom";
import { doLogout, isSubUserLoggedIn } from "../../../common/utility";
import { Paths } from "../../../Routes/path";
import arrowUpper from "../../../assets/svg/arrowUpper.svg";
import lock_icon from "../../../assets/svg/lock.svg";
import { getPartnershipOboardingStatus } from "../../../api/UserStatesAPI";
import Environments from "../../../Environments";


function useOutsideAlerter(ref, cbk) {
  useEffect(() => {
    function handleClickOutside(event) {
      if (ref.current && !ref.current.contains(event.target)) {
        cbk(false);
      }
    }
    document.addEventListener("mousedown", handleClickOutside);
    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
    };
    // eslint-disable-next-line
  }, [ref]);
}

const PartnerHeader = ({ user, cartItemData }) => {
  const [open, setOpen] = useState(false);
  const [partnershipStatus, setPartnershipStatus] = useState(null);
  const { lcoAdminId, user: userData, onboardingCompleted } = user || {};
  const { existingCartItemCount, cartItemCount } = cartItemData;
  const wrapperRef = useRef(null);
  useOutsideAlerter(wrapperRef, setOpen);
  const navigate = useNavigate();
  let isSubUser = isSubUserLoggedIn();

  useEffect(() => {
    const fetchPartnershipStatus = async () => {
      try {
        const response = await getPartnershipOboardingStatus();
        setPartnershipStatus(response);
      } catch (error) {
        console.error('Error fetching partnership status:', error);
      }
    };

    if (onboardingCompleted) {
      fetchPartnershipStatus();
    }
  }, [onboardingCompleted]);

  // Check if Mass Retail Dashboard should be shown based on partnership status
  // If response is an array with more than 1 LOB, it's considered multi-LOB
  const showMassRetailDashboard = Array.isArray(partnershipStatus) && partnershipStatus.length > 1;

  return (
    <div className={styles.headerComponent}>
      <div className={styles.headerElement}>
        <img
          src={partner_logo}
          alt="logo"
          className={styles.pointer}
          onClick={() => navigate("/partner/dashboard")}
        />
      </div>
      <div className={styles.headerElement}>
        {/* <img
          src={aircoin_icon}
          alt="logo"
          width={20}
          height={20}
          className={styles.pointer}
        /> */}
        {onboardingCompleted && (
          <div className={styles.cartBox}>
            <img
              src={cart_icon}
              alt="logo"
              width={20}
              height={20}
              className={styles.pointer}
              onClick={() => navigate(Paths.cart.path)}
            />
            <span>{existingCartItemCount || cartItemCount}</span>
          </div>
        )}
        {/* <img
          src={notification_partner}
          alt="logo"
          width={20}
          height={20}
          className={styles.pointer}
        />  */}
        <div className={styles.profileSection} onClick={() => setOpen(!open)}>
          <img
            src={profile_partner_icon}
            alt="logo"
            width={40}
            height={40}
            className={styles.pointer}
          />
          <div className={styles.idSection}>
            {userData && (
              <>
                <span className={styles.name}>
                  {userData.firstName +
                    " " +
                    (userData.lastName ? userData.lastName : "")}
                  {!lcoAdminId && (
                    <img
                      src={arrowUpper}
                      alt="uparrow"
                      className={`${styles.up} ${open && styles.open}`}
                      width={20}
                      height={20}
                    />
                  )}
                </span>
              </>
            )}
            {lcoAdminId && (
              <span className={styles.id}>
                {lcoAdminId}
                <img
                  src={arrowUpper}
                  alt="uparrow"
                  className={`${styles.up} ${open && styles.open}`}
                  width={20}
                  height={20}
                />
              </span>
            )}
          </div>

          {open && (
            <div ref={wrapperRef}>
              <div className={styles.profileOverlay} />
              <div className={styles.profileDropdown}>
                {onboardingCompleted && (
                  <>
                    {!isSubUser && <>
                      <div
                        className={`${styles.logout} ${styles.option}`}
                        onClick={() => {
                          navigate("/partner/dashboard/details?tabName=myProfile");
                        }}
                      >
                        <img src={profile_outlined} alt="profile" />
                        My Profile
                      </div>
                      <div
                        className={`${styles.logout} ${styles.option}`}
                        onClick={() => {
                          navigate(Paths.manageOrders.path);
                        }}
                      >
                        <img src={order_icon} alt="my orders" />
                        My Orders
                      </div>
                      <div
                        className={`${styles.logout} ${styles.option}`}
                        onClick={() => {
                          navigate(Paths.manageTeam.path);
                        }}
                      >
                        <img src={myTeam} alt="myTeam" />
                        My Team
                      </div>
                    </>
                    }
                  </>
                )}
                {showMassRetailDashboard && (
                  <div
                    className={`${styles.logout} ${styles.option}`}
                    onClick={() => {
                      // Navigate to Mass Retail Dashboard in new tab
                      window.open(Environments.getOadDashboardUrl() + "/dashboard", '_self');
                    }}
                  >
                    <img src={profile_outlined} alt="Mass Retail Dashboard" />
                    Mass Retail Dashboard
                  </div>
                )}
                {!isSubUser && <div
                  className={`${styles.logout} ${styles.option}`}
                  onClick={() => {
                    navigate(Paths.changePassword.path);
                  }}
                >
                  <img src={lock_icon} alt="change password" />
                  Change Password
                </div>}
                <div
                  className={`${styles.logout} ${styles.option}`}
                  onClick={() => {
                    doLogout();
                  }}
                >
                  <img src={logout_outlined} alt="logout" />
                  Log Out
                </div>
              </div>
            </div>
          )}
        </div>
      </div>
    </div>
  );
};

const mapStateToProps = (state) => ({
  lcoIdData: state.lcoIdData,
  user: state.userDetails,
  cartItemData: state.cartItemData
});

export default connect(mapStateToProps)(PartnerHeader);
